import React, {useEffect, useRef, useState} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import markerCss from '../Marker.module.css';
import {getIv, getSecsLeft, getPokemonIcon} from "../../../utils";
import Label from "../Label";
import css from './PokemonMarker.module.css';

const PokemonMarker = (props) => {
	const [secsLeft, setSecsLeft] = useState(getSecsLeft(props.pokemon.disappear_time));
	const timer = useRef(false);

	useEffect(() => {
		const secsUntilRefresh = secsLeft % 60 + 1;
		if( secsLeft > 0 )
			timer.current = setTimeout(() => {setSecsLeft(getSecsLeft(props.pokemon.disappear_time))}, secsUntilRefresh*1000);
		// console.log("Timer for " + props.pokemon.encounter_id, timer.current);
		// eslint-disable-next-line
	}, [secsLeft]);

	useEffect(() => {
		return () => {
			// console.log("Unmounting " + props.pokemon_encounter_id, timer.current);
			if( timer.current )
				clearTimeout(timer.current);
		}
		// eslint-disable-next-line
	}, []);

	if( secsLeft <= 0 )
		return null;

	const getLabel = () => {
		if (props.pokemon.quality < 20 && props.pokemonQuality !== 90)
			return null;

		// let weatherText = null;
		// if( pokemonIsWeatherBoosted(props.pokemon.pokemon_id, props.pokemon['s2-10']) )
		// 	weatherText = <img alt='Weather Boosted' src={'https://www.a2pogo.com/common/images/pokemon/weather/weather-' + props.weather[props.pokemon['s2-10']] + '.png'} width='20' />;

		let elts = [];
		if( props.pokemon.cp !== undefined && props.pokemon.cp !== null ) {
			const iv = getIv(props.pokemon);
			if( props.pokemon.quality >= 40 ||
				(props.pokemon.quality >= 20 && props.pokemon.level >= 30 )
			) {
				if( props.showPokemonLevel )
					elts.push(<div key='cp'>Level {props.pokemon.level}</div>);
				else
					elts.push(<div key='cp'>CP {props.pokemon.cp}</div>);
			}
			if( iv >= 87 )
				elts.push(<div key='iv'>{iv}%</div>)
		}

		if( props.pokemon.verified && secsLeft < 5*60 )
			elts.push(<div key='time'>{Math.floor(secsLeft/60)}m</div>);

		return elts.length === 0 ? null : elts;
	};

	let label = getLabel();

	let className = '';
	if (props.pokemon.quality >= 80)
		className = css.Best;
	else if (props.pokemon.quality >= 60)
		className = css.Great;
	else if (props.pokemon.quality >= 40)
		className = css.Good;

	return (<>
		{props.infoWindow}
		<div style={{zIndex: props.pokemon.quality}} className={[markerCss.Marker, className].join(' ')}>
			<div onClick={() => props.onClick(props.pokemon)}>
				<img alt={props.pokemon.name} className={css.Icon} src={getPokemonIcon(props.pokemon)} />
			</div>
			{label !== null && <Label classes={[className, css.Label]} text={label} />}
		</div>
	</>);
};

PokemonMarker.propTypes = {
	pokemon: PropTypes.object.isRequired,
	onClick: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
	return {
		pokemonQuality: state.filter.pokemonQuality,
		showPokemonLevel: state.settings.showPokemonLevel,
	};
};


export default connect(mapStateToProps)(PokemonMarker);